import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Form, Button, Container, Card, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';

const M12_Ejercicio6 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    
    const [respuestas, setRespuestas] = useState({
        analisis: [
            { idea_principal: '', palabras_clave: '' },
            { idea_principal: '', palabras_clave: '' },
            { idea_principal: '', palabras_clave: '' },
            { idea_principal: '', palabras_clave: '' }
        ],
        idea_global: '',
        mapa_mental: {
            nodo_central: 'Economía informal',
            ramas: [
                { nombre: 'Definición', detalles: '' },
                { nombre: 'Problemas', detalles: '' },
                { nombre: 'Beneficios', detalles: '' },
                { nombre: 'Soluciones', detalles: '' }
            ]
        },
        retencion: {
            ideas_recordadas: '',
            estructura_recordada: '',
            faltantes: ''
        }
    });

    const textoBase = `ECONOMÍA INFORMAL

La economía informal está compuesta por actividades económicas que no están reguladas por el Estado ni registradas oficialmente. Este tipo de economía es común en muchos países en desarrollo y suele incluir trabajos como el comercio ambulante, servicios no registrados y actividades independientes.

Uno de los principales problemas de la economía informal es que no contribuye directamente al sistema tributario, lo que afecta los ingresos del Estado. Además, los trabajadores informales no cuentan con protección social, seguridad laboral ni beneficios como salud o pensión.

Sin embargo, la economía informal también representa una fuente importante de ingresos para muchas personas que no tienen acceso a empleos formales. En este sentido, cumple una función social relevante al permitir la subsistencia de millones de familias.

El desafío para los gobiernos es encontrar un equilibrio entre la regulación de estas actividades y la generación de oportunidades para que estos trabajadores puedan integrarse al sistema formal sin perder sus fuentes de ingreso.`;

    const handleAnalisis = (index, campo, valor) => {
        const nuevoAnalisis = [...respuestas.analisis];
        nuevoAnalisis[index][campo] = valor;
        setRespuestas(prev => ({ ...prev, analisis: nuevoAnalisis }));
    };

    const handleRama = (index, valor) => {
        const nuevasRamas = [...respuestas.mapa_mental.ramas];
        nuevasRamas[index].detalles = valor;
        setRespuestas(prev => ({
            ...prev,
            mapa_mental: { ...prev.mapa_mental, ramas: nuevasRamas }
        }));
    };

    const handleRetencion = (campo, valor) => {
        setRespuestas(prev => ({
            ...prev,
            retencion: { ...prev.retencion, [campo]: valor }
        }));
    };

    const nextStep = () => {
        if (!modoConsulta && (step === 2)) {
            const incompleto = respuestas.analisis.some(p => !p.idea_principal.trim() || !p.palabras_clave.trim());
            if (incompleto) {
                Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Completa el análisis de todos los párrafos.' });
                return;
            }
        }
        if (!modoConsulta && (step === 3 && !respuestas.idea_global.trim())) {
            Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Escribe la síntesis global.' });
            return;
        }
        if (!modoConsulta && (step === 4)) {
            const ramasIncompletas = respuestas.mapa_mental.ramas.some(r => !r.detalles.trim());
            if (ramasIncompletas) {
                Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Completa los detalles de todas las ramas del mapa mental.' });
                return;
            }
        }
        setStep(prev => prev + 1);
    };
    
    const prevStep = () => setStep(prev => prev - 1);

    const calcularPuntaje = () => {
        let puntaje = 0;
        
        // Análisis (8 pts)
        respuestas.analisis.forEach(p => {
            if (p.idea_principal.trim() && p.palabras_clave.trim()) puntaje += 2;
        });
        
        // Síntesis (4 pts)
        if (respuestas.idea_global.length > 15) puntaje += 4;
        
        // Mapa (4 pts)
        if (respuestas.mapa_mental.ramas.every(r => r.detalles.length > 5)) puntaje += 4;
        
        // Retención (4 pts)
        if (respuestas.retencion.ideas_recordadas.length > 10 && respuestas.retencion.estructura_recordada.length > 10) puntaje += 4;

        return puntaje;
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        const { ideas_recordadas, estructura_recordada, faltantes } = respuestas.retencion;
        if (!ideas_recordadas.trim() || !estructura_recordada.trim() || !faltantes.trim()) {
            Swal.fire({ icon: 'warning', title: 'Incompleto', text: 'Completa tu evaluación de retención antes de enviar.' });
            return;
        }

        const puntajeFinal = calcularPuntaje();

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 6 - Mapas mentales + Retención",
                nivel: "Avanzado",
                modulo: "12",
                createdAt: new Date(),
                tipo: "Mapa Mental",
                respuestas: respuestas,
                puntaje: puntajeFinal,
                puntajeMaximo: 20
            });
            Swal.fire({
                title: '¡Evaluación Enviada!',
                text: `Resultados enviados con éxito. Puntaje estimado: ${puntajeFinal}/20.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then((result) => {
                if (result.isConfirmed) {
                    cerrarModal();
                }
            });
        } catch (error) {
            console.error("Error al enviar las respuestas: ", error);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Error al enviar las respuestas.' });
        }
    };

    return (
        <Container>
            <h3 className="text-center mb-4">Ejercicio 6 - Mapas Mentales y Retención</h3>
            
            {step === 1 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-primary">
                        <Card.Body>
                            <Card.Title>Paso 1: Lectura</Card.Title>
                            <Card.Text>Lee atentamente el siguiente texto para luego estructurarlo mentalmente.</Card.Text>
                            <div className="p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                                {textoBase}
                            </div>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente Paso</Button>
                    </div>
                </div>
            )}

            {step === 2 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-warning">
                        <Card.Body>
                            <Card.Title>Paso 2: Análisis por párrafo</Card.Title>
                            <Card.Text>Extrae la idea principal y palabras clave de cada párrafo.</Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <Form>
                        {respuestas.analisis.map((parrafo, index) => (
                            <Card key={index} className="mb-3 p-3 bg-light">
                                <h6 className="fw-bold text-primary">Párrafo {index + 1}</h6>
                                <Row>
                                    <Col md={8}>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Idea principal:</Form.Label>
                                            <Form.Control type="text" placeholder="Idea central del párrafo..." value={parrafo.idea_principal} onChange={e => handleAnalisis(index, 'idea_principal', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Palabras clave:</Form.Label>
                                            <Form.Control type="text" placeholder="Ej: informal, estado..." value={parrafo.palabras_clave} onChange={e => handleAnalisis(index, 'palabras_clave', e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card>
                        ))}
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente Paso</Button>
                    </div>
                </div>
            )}

            {step === 3 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-info">
                        <Card.Body>
                            <Card.Title>Paso 3: Síntesis Global</Card.Title>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold">¿Cuál es la idea principal de todo el texto?</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                placeholder="Escribe la idea central que engloba todo el texto..."
                                value={respuestas.idea_global} 
                                onChange={e => setRespuestas(prev => ({ ...prev, idea_global: e.target.value }))} 
                            />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente Paso</Button>
                    </div>
                </div>
            )}

            {step === 4 && (
                <div>
                    <Card className="mb-4 shadow-sm border-left-success">
                        <Card.Body>
                            <Card.Title>Paso 4 y 5: Construcción de Mapa Mental</Card.Title>
                            <Card.Text>
                                Organiza la información extraída en formato de mapa mental. El nodo central es <strong>"Economía informal"</strong>. 
                                Completa los detalles (subramas) para cada una de las ramas principales.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <div className="text-center mb-4">
                        <h4 className="p-3 bg-primary text-white rounded d-inline-block shadow">
                            {respuestas.mapa_mental.nodo_central}
                        </h4>
                    </div>

                    <Form>
                        <Row>
                            {respuestas.mapa_mental.ramas.map((rama, index) => (
                                <Col md={6} key={index}>
                                    <Card className="mb-3 border-primary">
                                        <Card.Header className="bg-light fw-bold text-center">{rama.nombre}</Card.Header>
                                        <Card.Body>
                                            <Form.Control 
                                                as="textarea" 
                                                rows={2} 
                                                placeholder={`Detalles sobre ${rama.nombre.toLowerCase()}...`}
                                                value={rama.detalles}
                                                onChange={e => handleRama(index, e.target.value)}
                                            />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="primary" size="lg" onClick={nextStep}>Siguiente: Retención</Button>
                    </div>
                </div>
            )}

            {step === 5 && (
                <div>
                    <Card className="mb-4 shadow-sm bg-dark text-white">
                        <Card.Body>
                            <Card.Title className="text-warning">Paso 6: Retención (Prueba de Memoria)</Card.Title>
                            <Card.Text>
                                El texto y tus apuntes anteriores han sido ocultados. Responde lo siguiente basándote solo en tu memoria.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">1. Escribe las ideas principales que recuerdes:</Form.Label>
                            <Form.Control as="textarea" rows={3} value={respuestas.retencion.ideas_recordadas} onChange={e => handleRetencion('ideas_recordadas', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">2. Reconstruye la estructura del mapa mental (ramas y subramas):</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Ej: Centro: Economía. Ramas: Problemas (no impuestos), Beneficios..." value={respuestas.retencion.estructura_recordada} onChange={e => handleRetencion('estructura_recordada', e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">3. ¿Qué información crees que olvidaste o te costó recordar?</Form.Label>
                            <Form.Control as="textarea" rows={2} value={respuestas.retencion.faltantes} onChange={e => handleRetencion('faltantes', e.target.value)} />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={prevStep}>Anterior</Button>
                        <Button variant="success" size="lg" onClick={enviarResultados}>Finalizar y Enviar</Button>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default M12_Ejercicio6;
